export enum enumAggregationType {
  FLAT = 100, // FE only
  PRICE = 0,
  WEIGHT = 1,
  CONTAINER = 2,
}
